<template>
    <grey-button data-toggle="modal" data-target="#helpcenterModal" class="bg-outside p-1 pl-1 pr-1">
        <div class="row d-flex justify-content-center">
            <div class="col-5 font-weight-bold">Fragen?</div>
            <div class="col-3 seperator d-flex justify-content-center align-items-center">
                <div v-if="navbarModalPhoneNumber == true">
                    <i class="fal fa-phone icon-size" alt="phone icon navbar"></i>
                </div>
                <div v-else>
                   <i class="fal fa-envelope icon-size" alt="email icon navbar"></i>
                </div>
            </div>
            <div class="col-3 d-flex justify-content-center align-items-center">
                <i class="fab fa-whatsapp icon-size icon-whatsapp" alt="whatsapp icon"></i>
            </div>
        </div>
    </grey-button>
</template>

<script>
export default {
    name: "ContactButton",

    props: {
        navbarModalPhoneNumber: {
            default: false,
        }
    },
}
</script>

<style scoped>
.bg-outside {
    width: 210px !important;
    height: 60px;
    cursor: pointer;
}
.seperator {
    border-right: 2px solid #dbdbdb;
}
.icon-whatsapp {
    font-size: 21px;
    color: #36acbb;
}
.icon-phone {
    height: 18px;
}
</style>
